import * as ActionsTypes from "../../../../common/constants/stateConstants";

/*---------------------------------------------GET-DETAIL-PACKAGE-------------------------------------------------*/
export const getDetailPackageAction = (payload) => {
  return {
    type: ActionsTypes.GET_DETAIL_PACKAGE,
    payload,
  };
};

export const getDetailPackageSuccessAction = (payload) => {
  return {
    type: ActionsTypes.GET_DETAIL_PACKAGE_SUCCESS,
    payload,
  };
};

export const getDetailPackageFailAction = (payload) => {
  return {
    type: ActionsTypes.GET_DETAIL_PACKAGE_FAIL,
    payload,
  };
};
